import { render, staticRenderFns } from "./DynamicModalMultipleEntity.vue?vue&type=template&id=28a8e058&scoped=true"
import script from "./DynamicModalMultipleEntity.vue?vue&type=script&lang=js"
export * from "./DynamicModalMultipleEntity.vue?vue&type=script&lang=js"
import style0 from "./DynamicModalMultipleEntity.vue?vue&type=style&index=0&id=28a8e058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8e058",
  null
  
)

export default component.exports